import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";
import { Link } from "react-router";
import { useAuthorization } from "@/hooks/use-authorization";
import { Permissions } from "@/utils/permissions";
import type { RegistryType } from "@/schemas/digital-files/registry";

export const DetailsMenu = ({
  registry,
  entityId,
  showInsolvency,
  onDelete,
  onAddInsolvency,
  onViewInsolvencies,
}: {
  entityId?: string;
  registry?: RegistryType;
  showInsolvency?: boolean;
  onDelete: () => void;
  onAddInsolvency: () => void;
  onViewInsolvencies: () => void;
}) => {
  const { hasPermission } = useAuthorization();
  const canUpdate = hasPermission(Permissions.expedient_base_registries.update);
  const canDelete = hasPermission(Permissions.expedient_base_registries.delete);

  if (!registry) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="quiet"
          size="icon"
          aria-label="Opciones"
          type="button"
          disabled={!canUpdate && !canDelete}
        >
          <Icon type="far" name="ellipsis-vertical" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn(
          "flex flex-col text-body rounded-lg border-[0.5px] border-neutral bg-neutral-object font-normal shadow-neutral-xl",
        )}
        side="bottom"
        align="end"
      >
        <DropdownMenuItem
          className="border-neutral-quiet gap-3 border-0 hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
          onClick={onAddInsolvency}
        >
          Asignar Infracción
          <Icon
            type="far"
            name="plus"
            className="text-current text-base leading-3xl"
          />
        </DropdownMenuItem>
        {showInsolvency && (
          <DropdownMenuItem
            className="border-neutral-quiet gap-3 border-b rounded-none hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            onClick={onViewInsolvencies}
          >
            Ver infracciones
          </DropdownMenuItem>
        )}
        {canUpdate && (
          <DropdownMenuItem
            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            asChild
          >
            <Link
              to={`/expedientes/entidad/${entityId}/registro/${registry.id}`}
            >
              Editar registro
            </Link>
          </DropdownMenuItem>
        )}

        {canUpdate && (
          <DropdownMenuItem
            className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
            onClick={onDelete}
          >
            Eliminar registro
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
